var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.243,
    height: 37.243,
    viewBox: "0 0 37.243 37.243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-eye-off",
    transform: "translate(0.621 0.621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5709",
    d: "M26.91,26.91A15.105,15.105,0,0,1,18,30C7.5,30,1.5,18,1.5,18A27.675,27.675,0,0,1,9.09,9.09m5.76-2.73A13.68,13.68,0,0,1,18,6C28.5,6,34.5,18,34.5,18a27.75,27.75,0,0,1-3.24,4.785m-10.08-1.6a4.5,4.5,0,1,1-6.36-6.36",
    fill: "none",
    stroke: "#4897d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5710",
    d: "M1.5,1.5l33,33",
    fill: "none",
    stroke: "#4897d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye_off.f9a4c62d5e9645cdbf96737736098b69.svg";
export { ForwardRef as ReactComponent };